<div
  class="workflow-context-bar-host__sr-only"
  data-testid="workflow-context-bar-announcer"
  aria-live="polite"
  aria-atomic="true"
>
  {{ announcement() }}
</div>

@if (context(); as activeContext) {
  @if (activeContext.visible && !hearingHeaderActive()) {
    <section
      class="workflow-context-bar-host"
      data-testid="workflow-context-bar"
      [attr.data-state]="activeContext.state"
      aria-labelledby="workflow-context-bar-title"
    >
      <h2 id="workflow-context-bar-title" class="workflow-context-bar-host__sr-only">
        Current workflow
      </h2>

      <phms-workflow-summary-bar
        [ledger]="activeContext.ledger"
        [state]="activeContext.state"
        [expanded]="activeContext.expanded && activeContext.state === 'ready' && !!activeContext.ledger"
        [controlsId]="ledgerRegionId(activeContext.token)"
        (expandedChange)="setExpanded(activeContext.token, $event)"
      ></phms-workflow-summary-bar>

      @if (activeContext.expanded && activeContext.state === "ready" && activeContext.ledger) {
        <div
          class="workflow-context-bar-host__ledger"
          data-testid="workflow-context-bar-ledger"
          [id]="ledgerRegionId(activeContext.token)"
          role="region"
          aria-label="Workflow history"
        >
          <phms-workflow-ledger
            [compact]="true"
            [ledger]="activeContext.ledger"
            [state]="activeContext.state"
          ></phms-workflow-ledger>
        </div>
      }
    </section>
  }
}
